import { Component, OnInit, ViewChild, ElementRef, Input } from '@angular/core';

@Component({
  selector: 'elv-section-header',
  templateUrl: './section-header.component.html',
  styleUrls: ['./section-header.component.scss'],
})
export class SectionHeaderComponent implements OnInit {

  @ViewChild('header', { static: true }) header: ElementRef;
  @Input() label: string;
  @Input() comment: string;
  @Input() color: string;
  @Input() height: string;
  @Input() pad: string;

  constructor() { }

  ngOnInit() {
    if (this.height) {
      this.header.nativeElement.style.setProperty('--min-height', this.height + 'px');
    }

    if (this.color) {
      this.header.nativeElement.style.setProperty('--background-color', `var(--ion-color-${this.color})`);
      this.header.nativeElement.style.setProperty('--background-color-shade', `var(--ion-color-${this.color}-shade)`);
    }

    // if (this.pad) {
    //   this.header.nativeElement.style.setProperty('--padding-top', this.pad + 'px');
    //   this.header.nativeElement.style.setProperty('--padding-bottom', this.pad + 'px');
    //   this.header.nativeElement.style.setProperty('--padding-start', this.pad + 'px');
    //   this.header.nativeElement.style.setProperty('--padding-end', this.pad + 'px');
    // }
  }

}
